import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { ciandtspikeDeleteEntityTranslations } from './resource';

const deleteEntityTranslations = TranslationBlueprint.make({
  name: 'ciandtspike-delete-entity',
  params: { resource: ciandtspikeDeleteEntityTranslations },
});

// TranslationBlueprint só aceita extensions do plugin `app`, portanto é
// entregue como FrontendModule do `app` para o host registrar em features[].
export const ciandtspikeDeleteEntityTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [deleteEntityTranslations],
});
